module.exports = __webpack_public_path__ + "img/doubleFrequencyMushroomAntenna.820e5cea.png";